// @ts-check

/** @type {TableColumn[]} */
const columns = [
  {
    id: 'submitted_at',
    text: 'Submission date',
    dataType: 'date',
    sortable: true,
  },
  {
    id: 'activity',
    text: 'Activity',
    sortable: true,
  },
  {
    id: 'campaign_export',
    text: 'Campaign export',
  },
  { id: 'submitted_by', text: 'Submitted by', sortable: true },
];

/** @type {TableConfig} */
const channelExportHistoryTableConfig = {
  caption: 'Channel export history',
  captionTotalText: '',
  columns,
  clientSorting: false,
  rowKeyId: null,
};

export { channelExportHistoryTableConfig };
